import { render, staticRenderFns } from "./ListAddresses.vue?vue&type=template&id=4ad9c28a"
import script from "./ListAddresses.vue?vue&type=script&lang=ts"
export * from "./ListAddresses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports